<script>
export default {
    name: "PrivacyPolicy"
}
</script>

<template>
    <div class="page">
        <div class="main_text">Политика конфиденциальности</div>
        <div class="other_info">
            <h2>Какую информацию о вас мы собираем</h2>
            <p>Типы данных, которые мы собираем и обрабатываем включают в себя следующее:</p>
            <ul>
                <li>Ваше реальное имя или никнейм на сайте.</li>
                <li>Ваш адрес электронной почты.</li>
                <li>Ваш IP-адрес.</li>
            </ul>
            <p>Дополнительные данные могут быть собраны, если вы решите поделиться ими, например, если вы заполните дополнительные поля в своем профиле.</p>
            <p>Мы собираем некоторую или всю эту информацию в следующих случаях:</p>
            <ul>
                <li>Вы регистрируетесь как участник на этом сайте.</li>
                <li>Вы используете нашу форму обратной связи.</li>
                <li>Вы просматриваете этот сайт. Смотрите пункт "Политика в отношении файлов cookie" ниже.</li>
                <li>Вы заполняете дополнительные поля в своем профиле.</li>
            </ul>

            <h2>Как используется ваша личная информация</h2>
            <p>Мы можем использовать вашу личную информацию в следующих целях:</p>
            <ul>
                <li>Для того, чтобы сделать вас зарегистрированным участником нашего сайта, чтобы вы могли добавлять на него контент.</li>
                <li>Мы можем использовать ваш адрес электронной почты, чтобы информировать вас об активности на нашем сайте.</li>
                <li>Ваш IP-адрес записывается при выполнении определенных действий на нашем сайте. Он никогда не отображается публично.</li>
            </ul>

            <h2>Другие варианты использования вашей личной информации</h2>
            <p>В дополнение к оповещениям вас об активности на нашем сайте, время от времени мы можем связываться со всеми пользователями посредством рассылки электронной почты или объявлений для того, чтобы рассказать им какую-либо важную информацию. вы можете отказаться от подобных рассылок в настройках своего профиля.</p>
            <p>В ходе вашего использования нашего сайта мы можем собирать информацию, не связанную с личными сведениями о вас. Эти данные могут содержать техническую информацию о браузере или типе устройства, которые вы используете. Эта информация будет использоваться исключительно для целей аналитики и отслеживания количества посетителей нашего сайта.</p>

            <h2>Обеспечение безопасности данных</h2>
            <p>Мы стремимся обеспечить безопасность любой информации, которую вы нам предоставляете. Чтобы предотвратить несанкционированный доступ или раскрытие информации, мы добавили подходящие меры и процедуры для защиты и обеспечения безопасности информации, которую мы собираем.</p>

            <h2>Политика в отношении файлов cookie</h2>
            <p>Cookie - это небольшие текстовые файлы, которые будут установлены нашим сайтом на ваш компьютер, они позволят нам предоставлять определенные функции на нашем сайте, такие как возможность входа в систему или запоминание определенных предпочтений.</p>

            <h2>Права</h2>
            <p>Вы имеете право получить доступ к личным данным, которые у нас имеются о вас, или получить их копию. Для этого свяжитесь с нами. Если вы считаете, что информация, которую мы о вас имеем является неполной или неточной, то вы можете попросить нас дополнить или исправить эту информацию.</p>
            <p>Вы также имеете право запросить удаление ваших личных данных.</p>

            <h2>Принятие политики</h2>
            <p>Дальнейшее использование нашего сайта означает ваше полное согласие с этой политикой. Если вы не согласны с нашей политикой, то пожалуйста, не используйте данный сайт. При регистрации мы также запросим ваше явное согласие с политикой конфиденциальности.</p>

            <h2>Изменения в политике</h2>
            <p>Мы можем вносить изменения в данную политику в любое время. Вам может быть предложено ознакомиться и повторно принять информацию в этой политике, если она изменится в будущем.</p>
        </div>
    </div>
</template>

<style scoped>
.page {
    margin-top: 100px;
}

.main_text {
    margin-top: 4.63vh;

    font-size: 4vh;
    font-style: normal;
    font-weight: 600;

    color: #FFF;

    margin-left: 17.2vw;
}

.other_info {
    font-size: 1.852vh;
    font-style: normal;
    font-weight: 500;

    color: #D8D8D8;
    width: 1200px;
    line-height: 150%;

    margin-top: 2.778vh;
    margin-left: 17.2vw;
}
</style>